import i18n, { InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import language files dynamically based on site version
const getSiteVersion = () => {
  return process.env.REACT_APP_DOMAIN || 'trendvision.ai';
};

// Import language resources
const loadResources = () => {
  const siteVersion = getSiteVersion();

  try {
    // Import language files for the current site version
    const ru = require(`./locales/${siteVersion}/ru.json`);
    const en = require(`./locales/${siteVersion}/en.json`);

    return {
      ru: { translation: ru },
      en: { translation: en }
    };
  } catch (error) {
    console.error(`Error loading language files for version ${siteVersion}:`, error);
  }
};

// Get the fixed language from environment variable if it exists
const getFixedLanguage = () => {
  const fixedLanguage = process.env.REACT_APP_FIXED_LANGUAGE;
  if (fixedLanguage && (fixedLanguage === 'ru' || fixedLanguage === 'en')) {
    return fixedLanguage;
  }
  return undefined;
};

// Configure i18n with proper typing

// If a fixed language is specified, use it and don't detect language
const fixedLanguage = getFixedLanguage();
if (fixedLanguage) {
  const i18nConfig: InitOptions = {
    resources: loadResources(),
    fallbackLng: 'ru',
    lng: fixedLanguage,
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes values
    }
  };

  // Initialize without language detector
  i18n
    .use(initReactI18next)
    .init(i18nConfig);
} else {
  // Use language detector as before
  const i18nConfig: InitOptions = {
    resources: loadResources(),
    fallbackLng: 'ru',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
    }
  };

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(i18nConfig);
}

export default i18n;
